import { render, staticRenderFns } from "./BigWheel.vue?vue&type=template&id=0ace0b08&scoped=true&"
import script from "./BigWheel.vue?vue&type=script&lang=js&"
export * from "./BigWheel.vue?vue&type=script&lang=js&"
import style0 from "./BigWheel.vue?vue&type=style&index=0&id=0ace0b08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ace0b08",
  null
  
)

export default component.exports